export default __webpack_public_path__ + "static/media/s8.b155c9b2.jpg";